/**
 * The active plans for the public site, from `GET /subscriptions/plans`, which
 * needs no sign-in. A failed load returns an empty list: the pages then leave
 * out prices rather than show an error to a visitor.
 */

import { useQuery } from '@tanstack/react-query';
import subscriptionService from '@/services/subscription';
import type { SubscriptionPlan } from '@/types/subscription';

export function usePublicPlans(): { plans: SubscriptionPlan[]; loading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['public-plans'],
    queryFn: async () => {
      try {
        const res = await subscriptionService.getAvailablePlans();
        if (!res.success) return [] as SubscriptionPlan[];
        return (res.data ?? []).filter((p) => p.is_active !== false);
      } catch {
        return [] as SubscriptionPlan[];
      }
    },
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return { plans: data ?? [], loading: isLoading };
}

export function planFor(plans: SubscriptionPlan[], moduleKey: string | undefined): SubscriptionPlan | undefined {
  return moduleKey ? plans.find((p) => p.module_key === moduleKey) : undefined;
}
